var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"logo":_vm.info.logo,"routerData":_vm.headers}}),_c('div',{staticClass:"content-container"},[_c('keep-alive',[_c('RouterView')],1)],1),_c('Footer',{attrs:{"footers":_vm.footers,"bottomdocs":_vm.bottomdocs,"info":_vm.info}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }